
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire136b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire136b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("LhzCw", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $08e205a2eb41e3e4$export$6503ec6e8aabbaf; }, function (v) { return $08e205a2eb41e3e4$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $08e205a2eb41e3e4$export$f7ad0328861e2f03; }, function (v) { return $08e205a2eb41e3e4$export$f7ad0328861e2f03 = v; });
var $08e205a2eb41e3e4$export$6503ec6e8aabbaf;
var $08e205a2eb41e3e4$export$f7ad0328861e2f03;
"use strict";
var $08e205a2eb41e3e4$var$mapping = new Map();
function $08e205a2eb41e3e4$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$08e205a2eb41e3e4$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $08e205a2eb41e3e4$var$resolve(id) {
    var resolved = $08e205a2eb41e3e4$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$08e205a2eb41e3e4$export$6503ec6e8aabbaf = $08e205a2eb41e3e4$var$register;
$08e205a2eb41e3e4$export$f7ad0328861e2f03 = $08e205a2eb41e3e4$var$resolve;

});

var $2d11da9053a27d92$exports = {};

(parcelRequire("LhzCw")).register(new URL("", import.meta.url).toString(), JSON.parse('["4YUU1","index.4aabe828.js","6lzKO","sw.828dab37.js","aCQ9r","DigitalReceptionLogo.d7555b02.png","8uc9C","FrontAssistLogo.2346804c.png","kY5Ya","DigitalReceptionBackground.31675855.png","3beAl","FrontAssistBackground.99f9b812.png","gGHjO","Wayfinding.55c1f7e0.js","5BQET","Info.21cfc140.js","8732B","Emergency.cc3b99cb.js","hsSiv","GeneralPractitioner.7248835b.js","j1zDl","Medications.cd92fc0b.js","koX2L","Pentax.c59d6135.js","9iFm8","start_call.3dee0044.mp3","lXIyP","call_ringing_repeat_me.59812b61.mp3","6GR5O","call_started_talk_now.c717fca3.mp3","aDVPf","end_call.a7ff8b5a.mp3","cezRK","silence.52400e66.mp3"]'));


//# sourceMappingURL=index.runtime.6cfd2c6f.js.map
